/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .module-opener-button[_ngcontent-%COMP%]{width:20px}[_nghost-%COMP%]   .module-opener-input[_ngcontent-%COMP%]{width:80px}"];
export { styles as styles };
